import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactApexChart from "react-apexcharts";
import moment from 'moment-timezone';
import { selectAllPosData } from "../../reducers/posAnalyticsSlice";

const PosAnalytics = ({colors = [], width, height}) => {
    const posData = useSelector((state) => selectAllPosData(state));
    const [series, setSeries] = useState([])
    const [options, setOptions] = useState({
        chart: {
            id: "pos-data-bars",
            type: 'line',
        },
        xaxis: {
            type: 'datetime',
            tickAmount: 2,
        },
        yaxis: {
            min: 0,
            max: 4,
            tickAmount: 4
        },
        legend: {
            position: 'right',
        },
        markers: {
            size: 5,
        },
        stroke: {
            // curve: 'smooth',
        },
        // colors: ['#27358b', '#3e307f', '#562b72', '#6d2666', '#842159', '#9b1b4d', '#b31640', '#ca1134', '#e10c27']
        }
    )

    const getOptionsWithColors = (colors) => {
        return (colors && colors.length > 0 ) ? {...options, colors: colors} : options
    }

    const dispatch = useDispatch();

    useEffect(() => {
      let nameSerie = null
      let wrappedSeries = []
      let data = []
      let posDataColors = []
  
      posData.forEach((entity) => {
        let date = moment.tz(entity.key, 'YYYY-MM-DD', 'UTC')
  
        let theColor = colors.find((c) => c.name === entity.name)
        if(theColor && !posDataColors.find(c => c === theColor.color)) posDataColors.push(theColor.color)
  
        if(nameSerie !== entity.name && nameSerie !== null) {
          wrappedSeries.push({
            name: nameSerie,
            data: data
          })
          nameSerie = entity.name
          data = []
        } else {
          nameSerie = entity.name
        }
        data.push([date.unix()*1000 , parseFloat(entity.value).toFixed(2)])
      })
  
      wrappedSeries.push({
        name: nameSerie,
        data: data
      })
  
      setOptions(getOptionsWithColors(posDataColors))
      setSeries(wrappedSeries)
  
    }, [dispatch, posData])

    return (<div className="mixed-chart">
        <ReactApexChart
            options={options}
            series={series}
            type="line"
            width={width} //"100%"
            height={height} //"400"
        />
    </div>)
}

export default PosAnalytics;